module.exports = __webpack_public_path__ + "static/ojilogo-743cff09b48261861cebffee72055c8c.svg";